import React, { Fragment, useContext } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';
import Grid from '@material-ui/core/Grid';
import { FormsGlobalContext } from '@mummssoftware/global-context';
import Typography from '@material-ui/core/Typography';
import { FajitaContext } from '../FajitaForms/Context';
import { SET_REQ_QUEST } from '../FajitaForms/Context/constants';
import { ReqFieldDiv, SwitchDiv } from '../../components/layout/WrapperDiv';
import defaults from '../../translations/en.json';

const StyledSwitch = withStyles((theme) => ({
  switchBase: {
    color: theme.palette.common.white,
    '&$checked': {
      color: theme.palette.primary.main,
    },
    '&$checked + $track': {
      backgroundColor: theme.palette.primary.main,
    },
  },
  checked: {},
  track: {},
}))(Switch);

// todo showSwitch comes from form listing?
type FormSwitchProps = {
  showSwitch?: boolean;
};

export const ReqFormSwitch = () => {
  const { reqQuest, reqSwitch, dispatch } = useContext(FajitaContext);
  const { fajitaQuestionnaireFormGlobal } = useContext(FormsGlobalContext);

  const showSwitch =
    reqSwitch &&
    !!fajitaQuestionnaireFormGlobal?.isInProgressFAJITA &&
    !fajitaQuestionnaireFormGlobal?.isPrintViewFAJITA &&
    !fajitaQuestionnaireFormGlobal?.isReadOnlyViewFAJITA;

  const handleReqChange = (event: any) => {
    dispatch({
      type: SET_REQ_QUEST,
      payload: !reqQuest,
    });
  };

  return (
    <Fragment>
      {showSwitch && (
        <SwitchDiv>
          <Typography
            component="div"
            variant="body2"
            style={{ letterSpacing: 0 }}
          >
            <Grid component="div" container alignItems="center">
              <ReqFieldDiv>{defaults.reqFields}</ReqFieldDiv>
              <Grid item>
                <StyledSwitch
                  checked={reqQuest}
                  onChange={handleReqChange}
                  name="checked"
                />
              </Grid>
            </Grid>
          </Typography>
        </SwitchDiv>
      )}
    </Fragment>
  );
};
export default ReqFormSwitch;
